import { RootState } from '../../../../init-store/index';

export const isMobileUa = ({ ua: { isMobile } }: RootState) => isMobile;

export const browserNameSelector = ({ ua: { BrowserName } }: RootState) => BrowserName;

export const isIOSSelector = ({ ua: { OSFamily } }: RootState) => OSFamily === 'iOS';

export const getUASelector = (state: RootState) => state.ua;

export const isSafariBasedSelector = ({ ua: { BrowserName: browserName } }: RootState) =>
    browserName === 'Safari' || ['Safari', 'MobileSafari'].includes(browserName);
